import cookie from './cookie'

const AUTH_TOKEN = 'authToken'
const REDIRECT_PATH = 'REDIRECT_PATH'

export function getToken (req) {
  return cookie.get(AUTH_TOKEN, req)
}

export function getRedirectPath (req) {
  return cookie.get(REDIRECT_PATH, req)
}
